
<template>
  <div class="content_box mt-4">
    <naj-alert v-if="user && user.isIndividualUser" type="information">
      <template slot="content">
        {{ local.bankruptcy.home.lawyerNotificationMessage }}
      </template>
    </naj-alert>
    <div class="bordered-tabs d-flex justify-content-between">
      <div>
        <v-tabs
          v-model="tab"
          class="pt-5"
          background-color="white"
          slider-color="rgb(54, 197, 186)"
          active-class="tab-active"
        >
          <v-tab
            v-for="tabButton in tabsButtons"
            :key="tabButton.href"
            class="tab-padding"
            :href="tabButton.href"
            @click="changeTab(tabButton)"
          >
            {{ tabButton.title }}
          </v-tab>
        </v-tabs>
      </div>
      <div class="d-flex new-request-btn mt-7">
        <naj-button
          v-if="showNewRequest"
          color="primary"
          @click="newRequest"
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          {{ selectedTab.componentName == 'mainRequestsTab' ? local.home.tabCommon.newRequest:local.common.submitRequest }}
        </naj-button>
      </div>
    </div>
    <v-row>
      <v-col cols="12">
        <v-tabs-items v-model="tab">
          <v-tab-item
            v-if="selectedTab.componentName == 'mainRequestsTab'"
            value="tab-1"
          >
            <main-requests-tab ref="mainRequestsTab"></main-requests-tab>
          </v-tab-item>
          <v-tab-item
            v-if="selectedTab.componentName == 'myRequestsTab'"
            value="tab-2"
          >
            <my-requests-tab ref="myRequestsTab"></my-requests-tab>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <naj-confirmation
      :show-modal="showVacationModal"
      :title="vacationModal.title"
      :message="vacationModal.message"
      :close-btn-label="local.common.close"
      @cancel="showVacationModal = false"
    ></naj-confirmation>
  </div>
</template>

<script>
import MainRequestsTab from './main-requests-tab.vue';
import MyRequestsTab from './my-requests-tab.vue';
import { createNamespacedHelpers } from 'vuex';
import Vacations from '@/modules/lawsuit/services/vacations';
const { mapActions, mapState } = createNamespacedHelpers('BankruptcyModule');
import { userType } from '@/helpers/enum';

export default {
  name: 'Bankruptcy',
  components: {
    MainRequestsTab,
    MyRequestsTab,
  },
  data() {
    return {
      userType,
      selectedTab: {},
      tab: null,
      tabsButtons: [
        {
          href: '#tab-1',
          title: this.local.bankruptcy.home.tabs.mainRequestsTab,
          componentName: 'mainRequestsTab',
          total: null,
        },
        {
          href: '#tab-2',
          title: this.local.bankruptcy.home.tabs.myRequestsTab,
          componentName: 'myRequestsTab',
          total: null,
        },
      ],
      showVacationModal: false,
      vacationModal: {
        title: null,
        message: null,
      },
    };
  },
  computed: {
    ...mapState({ user: state => state.currentUser }),
    showNewRequest() {
      if (this.user.isIndividualUser || this.user.userType === this.userType.najizLawyer)
        return true;

      if (this.user.isOrganizationUser && this.selectedTab.componentName != 'mainRequestsTab')
        return true;
      
      if (this.selectedTab.componentName == 'mainRequestsTab')
        return false;
      else if (this.user.loginType == 'governmental' && !this.user.isBankruptcyTrustee) {
        return true;
      }

      return false;
    },
  },
  watch: {},
  mounted() {
    this.selectedTab = this.tabsButtons[0];
    this.getBankruptcyUserInfo();
  },
  methods: {
    ...mapActions(['getBankruptcyUserInfo']),
    changeTab(tab) {
      if (tab != this.selectedTab) {
        this.selectedTab = tab;
      }
    },
    newRequest() {
      const service = Vacations.check();
      if (service.locked) {
        this.vacationModal = {
          title: this.local.lawsuitRequest.serviceNotAvailable,
          message: service.message,
        };

        this.showVacationModal = true;
      } else {
        if (this.selectedTab.componentName == 'mainRequestsTab')
          this.$router.push({ path: '/bankruptcy/request' });
        else
          this.$router.push({ path: '/bankruptcy/sub-request' });
      }
    },
  },
};

</script>

<style lang="scss" scoped>
.v-alert {
  background-color: #f2f6fb !important;
}
.tab-padding {
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 20px;
  color: var(--app-dark-primary-color) !important;
  .v-chip {
    cursor: pointer;
    color: #ffffff;
    background: var(--app-dark-primary-color) !important;
    border-radius: 0px !important;
  }
}
.tab-active {
  color: var(--app-primary-color) !important;
  font-weight: bold;

  .v-chip {
    background: var(--app-lighter-primary-color) !important;
  }
}

::v-deep .v-tabs {
  .v-tabs-bar {
    .v-tabs-slider-wrapper {
      height: 5px !important;
    }
  }
}
::v-deep .v-tab {
  max-width: unset;
}
</style>
